import {combineReducers} from 'redux';

import {reducer as reduxFormReducer} from 'redux-form'


import productFormReducers  from './productFormReducers';
import productReducers  from './productReducers';
import productSearchReducers  from './productSearchReducers';
import sellReducers  from './sellReducers';
import updateSellReducers  from './updateSellReducers';
import editProductFormReducers  from './editProductFormReducers';
import findProductReducers  from './findProductReducers';
import categoriesListReducers  from './categoriesListReducers';
import categoryProductsReducers  from './categoryProductsReducers';
import productAttributesWizardReducers  from './productAttributesWizardReducers';
import formReducers  from './formReducers';
import authReducers  from './authReducers';
import uiReducers  from './uiReducers';

import {routerReducer} from 'react-router-redux'


export default combineReducers({
    productForm: productFormReducers,
    product: productReducers,
    productSearch: productSearchReducers,
    findProduct: findProductReducers,
    sell: sellReducers,
    updateSell: updateSellReducers,
    editProductForm: editProductFormReducers,
    searchCategoriesList: categoriesListReducers,
    findCategoryProducts: categoryProductsReducers,
    productAttributesWizard: productAttributesWizardReducers,
    formActions: formReducers,
    auth: authReducers,
    ui:uiReducers,
    router: routerReducer,
    form: reduxFormReducer
});
